import React, { useState, useEffect, useContext, useCallback } from "react";
import { makeStyles } from "@material-ui/styles";
import {
  Card,
  Typography,
  Grid,
  CircularProgress,
  List,
  ListItem,
} from "@material-ui/core";
import Tooltips from "@material-ui/core/Tooltip";
import { FaMale, FaCircle } from "react-icons/fa";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  BarChart,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  Bar,
  LabelList,
  Sector,
} from "recharts";
import Timeperiod from "../../Item/Timeperiod";
import Linechartapi from "../../Item/linechartapi";
import Barcharincome from "../../Item/barcharincome";
import { LangContext } from "../../../Context/Langcontext";
import { UserContext } from "../../../Context/UserContext";
import { getUsageStat } from "../../../API/Usage";

const useStyle = makeStyles((theme) => ({
  root: {
    width: "99.5%",
    height: "100%",
  },
  cardapi: {
    width: "100%",
    backgroundColor: "#FFFFFF",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    boxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    WebkitBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    borderRadius: 8,
    marginTop: "0.5rem",
    marginBottom: "0.7rem",
    maxHeight: "auto",
  },
  maintext: {
    fontSize: "1rem",
    fontWeight: 700,
    color: "#595A5A",
  },
  sectext: {
    fontSize: "1rem",
    fontWeight: 700,
    color: "#595A5A",
  },
  thitext: {
    fontSize: "1rem",
    fontWeight: 200,
    color: "#595A5A",
  },
  icon: {
    color: "#E16733",
    height: "8rem",
    width: "auto",
    marginBottom: "1rem",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  iconmea: {
    color: "rgb(241, 179, 81)",
    height: "8rem",
    width: "auto",
    marginBottom: "1rem",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  itemcenter: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  income: {
    width: "100%",
    backgroundColor: "#FFFFFF",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    boxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    WebkitBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    borderRadius: 8,
    marginTop: "0.5rem",
    maxHeight: "auto",
  },
  cardtooltip: {
    margin: "1rem",
    display: "flex",
    width: "100%",
    alignItems: "center",
    flexDirection: "column",
    zIndex: 99999,
    backgroundColor: "#ffffff87",
    borderRadius: 8,
    boxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    WebkitBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
  },
  fonttooltip: {
    fontSize: "0.7rem",
    fontWeight: 400,
    color: "#595A5A",
  },
  fontlabel: {
    fontSize: "0.8rem",
    fontWeight: 700,
    color: "#595A5A",
  },
}));

const Dashboard = () => {
  const classes = useStyle();
  const [loading, setloading] = useState(false);
  const [loadline, setLoadline] = useState(false);
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;
  const [fetch, setfetch] = useState(false);
  const userContext = useContext(UserContext);
  const user = userContext.data;
  // const serviceContext = useContext(ServiceContext);
  const [sum, setSum] = useState([]);
  const [active, setActive] = useState(0);
  const [date, setDate] = useState({
    start: new Date(),
    end: new Date(),
    set: true,
  });

  const [state, setState] = useState({
    datetype: "lastweek",
  });

  const data = [
    {
      name: "MEA User",
      value: user.filter((rs) => {
        return rs.role === "officer";
      }).length,
    },
    {
      name: "Customer",
      value: user.filter((rs) => {
        return (
          rs.role !== "admin" && rs.role !== "root" && rs.role !== "officer"
        );
      }).length,
    },
  ];
  const COLORS = ["#F1B351", "#E16733"];

  const RADIAN = Math.PI / 180;
  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
    index,
  }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
    return (
      <text
        x={x}
        y={y}
        fill="white"
        textAnchor={x > cx ? "start" : "end"}
        dominantBaseline="central"
      >
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    );
  };

  const chart = [
    {
      Contract: user.filter((rs) => {
        return rs.role === "contract";
      }).length,
      Officer: user.filter((rs) => {
        return rs.role === "officer";
      }).length,
      Public: user.filter((rs) => {
        return rs.role === "public";
      }).length,
    },
  ];

  const convertiso = (date) => {
    let diso = new Date(date).toISOString();
    let ymd = diso.substring(0, 11);

    return `${ymd}00:00:00Z`;
  };

  const convertiso23 = (date) => {
    let diso = new Date(date).toISOString();
    let ymd = diso.substring(0, 11);

    return `${ymd}23:00:00Z`;
  };

  const getData = useCallback(async () => {
    let input = "";
    if (state.datetype === "lastweek") {
      let d1 = new Date();
      let d2 = new Date();
      d1.setDate(d1.getDate() - 7);
      let d1utc = new Date(convertiso(d1));
      let d2utc = new Date(convertiso23(d2));
      let ts1tamputc = Math.floor(d1utc.getTime() / 1000);
      let ts2tamputc = Math.floor(d2utc.getTime() / 1000);

      input = `/aggregate?datetime_ref=${ts1tamputc},${ts2tamputc}&group=service_id,user_id,datetime_ref,apikey_id&sort=_id.datetime_ref:asc`;
    } else if (state.date === "lastmonth") {
      let d1 = new Date();
      let d2 = new Date();
      d1.setMonth(d1.getMonth() - 1);
      let d1utc = new Date(convertiso(d1));
      let d2utc = new Date(convertiso23(d2));
      let ts1tamputc = Math.floor(d1utc.getTime() / 1000);
      let ts2tamputc = Math.floor(d2utc.getTime() / 1000);
      input = `/aggregate?datetime_ref=${ts1tamputc},${ts2tamputc}&group=service_id,user_id,datetime_ref,apikey_id&sort=_id.datetime_ref:asc`;
    } else if (state.date === "lastyear") {
      let d1 = new Date();
      let d2 = new Date().toUTCString();
      d1.setFullYear(d1.getFullYear() - 1);
      let d1utc = new Date(convertiso(d1));
      let d2utc = new Date(convertiso23(d2));
      let ts1tamputc = Math.floor(d1utc.getTime() / 1000);
      let ts2tamputc = Math.floor(d2utc.getTime() / 1000);
      input = `/aggregate?datetime_ref=${ts1tamputc},${ts2tamputc}&group=service_id,user_id,datetime_ref,apikey_id&sort=_id.datetime_ref:asc`;
    } else if (state.date === "customperiod") {
    }
    const get = await getUsageStat(input);
    if (get.status.code === 200) {
      setSum(get.data);
    }
  }, [state]);

  useEffect(() => {
    if (!fetch) {
      setloading(true);
      setTimeout(() => {
        getData();
        setloading(false);
      }, 1000);
      setfetch(true);
    } else {
    }
  }, [fetch, getData]);

  const convertDate = (date) => {
    const monthNames = [
      lang.January,
      lang.February,
      lang.March,
      lang.April,
      lang.May,
      lang.June,
      lang.July,
      lang.August,
      lang.September,
      lang.October,
      lang.November,
      lang.December,
    ];
    let dateObj = new Date(date);
    let month = monthNames[dateObj.getMonth()];
    let day = String(dateObj.getDate()).padStart(2, "0");
    return state.datetype === "lastyear" ? `${month}` : `${day} ${month}`;
  };

  // const rename = (s_id) => {
  //   const name = serviceContext.data.find((rs) => {
  //     return rs._id === s_id;
  //   });
  //   if (name) {
  //     return name.name;
  //   } else {
  //     return null;
  //   }
  // };

  const reData = (e) => {
    let output = [];
    e.sort((a, b) =>
      a._id.datetime_ref > b._id.datetime_ref ? 1 : -1
    ).forEach(function (item) {
      var existing = output.filter(function (v, i) {
        return v.name === convertDate(item._id.datetime_ref);
      });

      if (existing.length) {
        var existingIndex = output
          .map((rs) => {
            return rs.name;
          })
          .indexOf(convertDate(item._id.datetime_ref));

        output[existingIndex][item._id.service_id] = Number(
          Number(
            output[existingIndex][item._id.service_id]
              ? output[existingIndex][item._id.service_id]
              : 0
          ) + Number(item.sum_request)
        );
      } else {
        if (typeof convertDate(item._id.datetime_ref) === "string") {
          let input = {};
          input.name = convertDate(item._id.datetime_ref);
          input[item._id.service_id] = item.sum_request;
          output.push(input);
        }
      }
    });
    return output;
  };

  const reDataIncome = (e) => {
    let output = [];
    e.sort((a, b) =>
      a._id.datetime_ref > b._id.datetime_ref ? 1 : -1
    ).forEach(function (item) {
      var existing = output.filter(function (v, i) {
        return v.name === convertDate(item._id.datetime_ref);
      });

      if (existing.length) {
        var existingIndex = output
          .map((rs) => {
            return rs.name;
          })
          .indexOf(convertDate(item._id.datetime_ref));

        output[existingIndex].income = Number(
          Number(
            Number(
              output[existingIndex].income
                ? Number(output[existingIndex].income)
                : 0
            ) + Number(item.sum_net)
          ).toFixed(2)
        );
      } else {
        if (typeof convertDate(item._id.datetime_ref) === "string") {
          let input = {};
          input.name = convertDate(item._id.datetime_ref);
          input.income = item.sum_net;
          output.push(input);
        }
      }
    });
    return output;
  };

  const mergData = () => {
    let mdata = reData(sum);
    return mdata;
  };

  const IncomeData = () => {
    let idata = reDataIncome(sum);
    return idata;
  };

  const renderActive = (props) => {
    let {
      cx,
      cy,
      midAngle,
      innerRadius,
      outerRadius,
      startAngle,
      endAngle,
      fill,
    } = props;
    const sin = Math.sin(-RADIAN * midAngle);
    const cos = Math.cos(-RADIAN * midAngle);
    const sx = cx + (outerRadius + 0) * cos;
    const sy = cy + (outerRadius + 0) * sin;
    const mx = cx + (outerRadius + 20) * cos;
    const my = cy + (outerRadius + 20) * sin;
    const ex = mx + (cos >= 0 ? 1 : -1) * 22;
    const ey = my;
    const textAnchor = cos >= 0 ? "start" : "end";
    return (
      <g>
        <Sector
          cx={cx}
          cy={cy}
          innerRadius={innerRadius}
          outerRadius={outerRadius + 6}
          startAngle={startAngle}
          endAngle={endAngle}
          fill={fill}
        />
        <path
          d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`}
          stroke={fill}
          fill="none"
        />
        <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
        <text
          x={ex + (cos >= 0 ? 1 : -1) * 12}
          y={ey}
          textAnchor={textAnchor}
          fill={props.fill}
        >{`${props.payload.payload.value} คน`}</text>
      </g>
    );
  };

  const renderTooltip = (props) => {
    let { payload } = props;
    if (props.active) {
      return (
        <Card className={classes.cardtooltip}>
          <List>
            {payload.map((entry, index) => {
              return (
                <ListItem key={`${entry.dataKey}_${index}`}>
                  <Grid container>
                    <Grid
                      item
                      xs={12}
                      style={{
                        display: "flex",
                        width: "100%",
                        alignItems: "center",
                      }}
                    >
                      <FaCircle
                        color={entry.color}
                        size={12}
                        style={{ margin: "0rem 0.5rem" }}
                      />
                      <Typography className={classes.fonttooltip}>
                        {`${entry.dataKey} : ${entry.value}`}
                      </Typography>
                    </Grid>
                  </Grid>
                </ListItem>
              );
            })}
          </List>
        </Card>
      );
    } else {
      return null;
    }
  };

  return (
    <div className={classes.root}>
      <Card className={classes.cardapi}>
        <Grid container spacing={0}>
          <Grid item md={6} sm={12} xs={12}>
            <div style={{ margin: "2rem" }}>
              <Tooltips
                title="กราฟแสดงจำนวนของของผู้ใช้งานในแต่ประเภท"
                placement="top-start"
              >
                <Typography className={classes.maintext}>
                  {lang.UserType}
                </Typography>
              </Tooltips>

              <Grid container justify="center">
                {loading ? (
                  <CircularProgress />
                ) : (
                  <div
                    style={{
                      margin: "1rem",
                      display: "flex",
                      width: "100%",
                      alignItems: "center",
                    }}
                  >
                    <Grid item md={3} sm={12} xs={12}>
                      <div className={classes.itemcenter}>
                        <FaMale className={classes.iconmea} />
                        <Typography className={classes.sectext}>
                          {data[0].value.toLocaleString()}
                        </Typography>
                        <Typography className={classes.thitext}>
                          {langContext.lang.locale === "en"
                            ? `MEA User`
                            : `ผู้ใช้งาน MEA`}
                        </Typography>
                      </div>
                    </Grid>
                    <Grid
                      item
                      md={6}
                      sm={12}
                      xs={12}
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <div style={{ width: "100%", height: 240 }}>
                        <ResponsiveContainer>
                          <PieChart>
                            <Pie
                              activeShape={renderActive}
                              activeIndex={active}
                              isAnimationActive={false}
                              data={data}
                              labelLine={false}
                              label={renderCustomizedLabel}
                              outerRadius={80}
                              fill="#8884d8"
                              dataKey={"value"}
                              onMouseEnter={(d, i) => {
                                setActive(i);
                              }}
                            >
                              {data.map((entry, index) => (
                                <Cell
                                  key={index}
                                  fill={COLORS[index % COLORS.length]}
                                />
                              ))}
                            </Pie>
                          </PieChart>
                        </ResponsiveContainer>
                      </div>
                    </Grid>
                    <Grid item md={3} sm={12} xs={12}>
                      <div className={classes.itemcenter}>
                        <FaMale className={classes.icon} />
                        <Typography className={classes.sectext}>
                          {data[1].value.toLocaleString()}
                        </Typography>
                        <Typography className={classes.thitext}>
                          {lang.Customer}
                        </Typography>
                      </div>
                    </Grid>
                  </div>
                )}
              </Grid>
            </div>
          </Grid>
          <Grid item md={6} sm={12} xs={12}>
            <div style={{ margin: "2rem" }}>
              <Tooltips
                title="กราฟแสดงจำนวนของของลูกค้าที่งานในแต่ประเภท"
                placement="top-start"
              >
                <Typography className={classes.maintext}>
                  {langContext.lang.locale === "en"
                    ? `${lang.Customer} ${lang.Type}`
                    : `${lang.Type}${lang.Customer}`}
                </Typography>
              </Tooltips>

              {loading ? (
                <div style={{ textAlign: "center" }}>
                  <CircularProgress />
                </div>
              ) : (
                <div style={{ width: "100%", height: 240 }}>
                  <ResponsiveContainer>
                    <BarChart
                      data={chart}
                      margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
                      layout="vertical"
                      barSize={30}
                    >
                      <XAxis type="number" />
                      <YAxis dataKey="name" type="category" />
                      <Tooltip content={renderTooltip} />
                      <Legend align="left" />
                      <Bar
                        isAnimationActive={false}
                        dataKey="Contract"
                        fill="#ADCAC8"
                        label="Contract"
                      >
                        <LabelList dataKey="Contract" position="right" />
                      </Bar>
                      <Bar
                        isAnimationActive={false}
                        dataKey="Officer"
                        fill="#F1B351"
                        label="Officer"
                      >
                        <LabelList dataKey="Officer" position="right" />
                      </Bar>
                      <Bar
                        isAnimationActive={false}
                        dataKey="Public"
                        fill="#BFC0BF"
                        label="Public"
                      >
                        <LabelList dataKey="Public" position="right" />
                      </Bar>
                    </BarChart>
                  </ResponsiveContainer>
                </div>
              )}
            </div>
          </Grid>
        </Grid>
      </Card>
      <Card className={classes.cardapi}>
        <Grid container>
          <Grid item xs={12}>
            <Timeperiod
              state={state}
              setState={setState}
              convertiso={convertiso}
              convertiso23={convertiso23}
              setSum={setSum}
              date={date}
              setDate={setDate}
              setloading={setLoadline}
            />
          </Grid>
        </Grid>
      </Card>
      <Card className={classes.cardapi}>
        <Grid container justify="center">
          <Grid item xs={12}>
            <Linechartapi
              type="single"
              data={mergData()}
              sum={sum}
              loading={loadline}
              setloading={setLoadline}
            />
          </Grid>
        </Grid>
      </Card>
      <Card className={classes.income}>
        <Grid container justify="center">
          <Grid item xs={12}>
            <Barcharincome data={IncomeData()} />
          </Grid>
        </Grid>
      </Card>
    </div>
  );
};

export default Dashboard;
